/* eslint-disable @next/next/no-script-component-in-head */
'use client'

import AboutFruit from '@/components/AboutFruit'
import Toaster from '@/components/base/Toaster'
import CounterSection from '@/components/CounterSection'
import Footer from '@/components/layout/Footer'
import Header from '@/components/layout/Header'
import LongBanner from '@/components/LongBanner'
import { clearToast } from '@/redux/features/toastSlice'
import { setSessionId } from '@/redux/features/userSlice'
import actionHandler from '@/utils/actionHandler'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { parseCookies } from 'nookies'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

export default function ClientProvider({ children, staticData, categoryMenu }) {
  const dispatch = useDispatch()
  const toast = useSelector((state) => state?.toast)

  useEffect(() => {
    const cookies = parseCookies()
    const cookiesSessionId = cookies?.sessionId
    if (cookiesSessionId) {
      dispatch(setSessionId(cookiesSessionId))
    }
    dispatch(clearToast())
  }, [])

  useEffect(() => {
    if (categoryMenu?.action) {
      actionHandler(categoryMenu?.action)
    }
  }, [categoryMenu])

  return (
    <>
      <main>
        <GoogleOAuthProvider clientId={process.env.GOOGLE_CLIENT_ID}>
          <Header categoryMenu={categoryMenu} />
          {children}

          <Footer staticData={staticData} />
        </GoogleOAuthProvider>
        {toast?.show && (
          <Toaster text={toast?.text} variation={toast?.variation} />
        )}
      </main>
    </>
  )
}
